import Vue, { watchEffect } from 'vue';
import Router from 'vue-router';
import { ROLES } from '@/constants/roles';

import getModulesRoutes from './getModulesRoutes';
import routeHandler from './routeHandler';

import User from '@/utils/user.js';

export const defaultMain = {
  path: '/',
  name: 'main',
  meta: {
    title: 'Главная',
    icon: 'mdi-home-outline',
    instruction: {
      id: { [ROLES.certificate]: 47, [ROLES.member]: 47 },
      name: 'Запись на мероприятие',
    },
  },
};

const userRedesignMain = {
  ...defaultMain,
  component: () => import('@/modules/ActivitiesCalendar/views/activities.vue'),
  meta: {
    title: 'Календарь активностей',
    layout: 'redesign',
    fluidContainer: true,
  },
};

const MAINPAGE_COMPONENT_BY_ROLE = {
  [ROLES.organization]: {
    ...defaultMain,
    component: () => import('@/modules/Dashboard/views/dashboard.vue'),
    meta: {
      ...defaultMain.meta,
      title: 'Рабочий стол',
      buttonTitle: 'Главная',
      layout: 'ui-design',
    },
  },
  [ROLES.admin]: {
    ...defaultMain,
    component: () => import('@/modules/Admin/views/admin-placeholder.vue'),
  },
  [ROLES.expert]: {
    ...defaultMain,
    component: () => import('@/modules/Dashboard/views/expert-dashboard.vue'),
  },
  // default for authorized
  default: {
    ...defaultMain,
    component: () => import('@/modules/Events/views/main-event-list-new.vue'),
    // component: () => import('@/modules/Events/views/main-event-list.vue'),
    meta: {
      ...defaultMain.meta,
      hasSearch: true,
    },
  },
  [ROLES.member]: userRedesignMain,
  [ROLES.certificate]: userRedesignMain,
  // default for non-authorized
  guest: {
    ...defaultMain,
    component: () => import('@/modules/Events/views/main-event-list-new.vue'),
    // component: () => import('@/modules/Instructions/views/instructions-by-roles.vue'),
  },
};

export const initRouter = () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
  });

  /**
   * Watch and setup routes by role.
   *
   * It can be work without watchEffect via hard reload page after each authenticate
   */
  watchEffect(() => {
    const user = new User();
    let mainPage = MAINPAGE_COMPONENT_BY_ROLE.guest;
    const { isAuthenticated, role } = user;

    if (isAuthenticated) {
      mainPage = MAINPAGE_COMPONENT_BY_ROLE[role.name] ? MAINPAGE_COMPONENT_BY_ROLE[role.name] : MAINPAGE_COMPONENT_BY_ROLE.default;
    }

    const routes = getModulesRoutes(user);
    routes.push(mainPage);

    const newRouter = new Router({
      mode: 'history',
      routes,
    });
    router.matcher = newRouter.matcher;
  });

  router.beforeEach(routeHandler);

  return { router };
};

export default { initRouter };
